import type { KieModelConfig, InputPayloadType } from './types';
import { kieModelConfigs } from './config';
import { translateToEnglish } from '../../shared/translate';
import { needsTranslation } from '../../image/tools';

/**
 * 获取模型配置
 */
export function getKieModelConfig(modelId: string): KieModelConfig {
    const config = kieModelConfigs[modelId];
    if (!config) {
        throw new Error(`Model ${modelId} not found`);
    }
    return config;
}

/**
 * 构建输入参数
 */
export async function buildInputPayloadFromConfig(
    modelId: string,
    params: {
        prompt: string;
        imagePrompt?: string[];
        videoUri?: string;
        videoUris?: string[];
        audioUri?: string;
        audioUris?: string[];
        duration: number;
        aspectRatio?: string;
        quality?: string;
        modelUi?: Record<string, any>;
        providerOptions?: Record<string, Record<string, any>>;
    }
): Promise<InputPayloadType> {
    // 获取服务商配置
    const config = getKieModelConfig(modelId);

    // 提示词翻译（配置开启，或 UI 高级选项开启）
    let prompt = params.prompt;
    const translateFromUi = (params.providerOptions as any)?.translate_to_english === true;
    if ((config.enableTranslation || translateFromUi) && needsTranslation(prompt)) {
        try {
            prompt = await translateToEnglish(prompt);
        } catch (error) {
            console.error(`[KIE][${modelId}] Failed to translate prompt:`, error);
        }
    }

    // 构建输入参数
    const result = await config.buildInput({ ...params, prompt });

    return result;
}